import notification from '../../../services/notification-service'
import productService from '../../../services/product-service'

export default {
    name: 'Manual',
    data() {
        return {
            id: '',
            quantity: 1,
            searchResults: []
        }
    },
    methods: {
        async add() {
            const response = await productService.getProductById(this.id)
            if (response.error) {
                notification.notify(this.$i18n.t('notifications.oops'), response.readable, "error")
            } else {
                response.data ? this.$store.dispatch('cart/updateOrAddCart', {product: response.data, quantity: productService.getCorrectQuantity(response.data, this.quantity)}) : notification.notify(this.$i18n.t('notifications.unfortunately'), this.$i18n.t('notifications.productWithIdNotFound', {id: this.id}), "warn") 
            }
            this.emptyFields()
        },
        emptyFields() {
            this.id = ''
            this.quantity = 1
            const el = document.getElementById('id-input')
            if (el) el.focus()
        },
        goToQuantity() {
            const el = document.getElementById('quantity-input')
            if (el) el.select()
        },
        async fetchSearchResults() {
            if (this.id) {
                const response = await productService.getManualInputProducts(this.id)
                response.error ? notification.notify(this.$i18n.t('notifications.oops'), response.readable, "error") : this.searchResults = response.data
            } else {
                this.searchResults = []
            }
        },
        setImageNotFound(event) {
            event.target.src = "/img/no-image-available.png"
        }
    },
    created() {
        this.$store.dispatch('cart/retrieveShoppingBasket')
    }
}